module.exports = __webpack_public_path__ + "static/media/report.b873ff3b.svg";